import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';
import { BeaconControl } from '@trp-beacon-ui-kit/foundation/components/beacon-control';

const projectNamePrefix = 'rmd';
export const RMDBeaconControl = registerReactComponent(
    projectNamePrefix,
    BeaconControl
);
